export default __webpack_public_path__ + "static/media/example-art-bad.f9fad236.webp";